<template>
  <div
    data-test="information-card-order-total"
    class="information-card-order-total"
  >
    <InformationCard heading="Total" :read-only="true">
      <div
        class="information-card-order-total__info-container body--p1--regular"
      >
        <template v-for="(item, index) in order.items" :key="index">
          <p class="information-card-order-total__info-column1">
            {{ item.name }}
          </p>
          <p class="information-card-order-total__info-column2">
            {{ '$' + item.price.toFixed(2) }}
          </p>
        </template>
        <p class="information-card-order-total__info-column1">GST</p>
        <p class="information-card-order-total__info-column2">
          {{ '$' + order.tax.toFixed(2) }}
        </p>
      </div>
      <div
        :class="[
          'information-card-order-total__info-container',
          'information-card-order-total__info-container--last',
          'body--p1--regular'
        ]"
      >
        <p class="information-card-order-total__info-column1">Total</p>
        <p class="information-card-order-total__info-column2">
          {{ '$' + order.total.toFixed(2) }}
        </p>
        <!--
        <p
          v-if="order.points"
          class="information-card-order-total__info-column1"
        >
          Points Earned
        </p>
        <p
          v-if="order.points"
          class="information-card-order-total__info-column2"
        >
          {{ order.points }}
        </p>-->
      </div>
    </InformationCard>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import InformationCard from '@base/components/InformationCard/InformationCard.vue'
import { OrderTotal } from './OrderTotalType'

export default defineComponent({
  name: 'InformationCardOrderTotal',
  components: { InformationCard },
  props: {
    order: {
      type: Object as PropType<OrderTotal>,
      required: true
    }
  }
})
</script>

<style lang="scss" scoped>
.information-card-order-total {
  &__info-container {
    column-gap: var(--spacing--4);
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-rows: auto;
    row-gap: var(--spacing--8);

    &:first-child {
      padding-bottom: var(--spacing--7);
    }

    &:last-child {
      border-top: var(--line-weight--light) solid var(--color--neutral-a4);
      padding-top: var(--spacing--7);
    }
  }

  &__info-column1 {
    color: var(--color--neutral-a3);
  }

  &__info-column2 {
    text-align: right;
  }
}
</style>
